<!-- ================================================================
     SEHYOG ACADEMY — 11+ FOCUSED CLASSES PAGE
     Angular 7 | Brand: #06253A / #0B4F6C / #01BAEF / #F5A623
     All classes prefixed: ep-
================================================================ -->
<div class="ep-page">

  <!-- ══════════════════════════════════════════════════════════════
       HERO SECTION
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-hero">
    <div class="ep-hero-bg"></div>
    <div class="ep-hero-grid-overlay"></div>
    <div class="ep-orb ep-orb-a"></div>
    <div class="ep-orb ep-orb-b"></div>
    <div class="ep-orb ep-orb-c"></div>

    <div class="ep-container">
      <div class="ep-hero-inner">

        <!-- Left: Text Content -->
        <div class="ep-hero-left">
          <div class="ep-hero-badge">
            <span class="ep-badge-pulse"></span>
            11+ Entrance Exam Specialists
          </div>

          <h1 class="ep-hero-h1">
            11<span class="ep-plus">+</span> Focused Classes<br/>
            <em>&amp; Exam Preparation</em>
          </h1>

          <div class="ep-boards-row">
            <span class="ep-board-chip">GL</span>
            <span class="ep-board-chip">CSSE</span>
            <span class="ep-board-chip ep-chip-gold">FSCE</span>
            <span class="ep-board-chip">SET</span>
          </div>

          <div class="ep-mode-row">
            <span class="ep-mode-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              Online 1-2-1
            </span>
            <span class="ep-mode-sep">·</span>
            <span class="ep-mode-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              Group Classes
            </span>
          </div>

          <p class="ep-hero-lead">
            Expert-led, structured preparation from Year 3 to Year 5 with personalised feedback,
            full mock exams and a proven track record at top UK grammar schools.
          </p>

          <div class="ep-hero-btns">
            <button class="ep-btn-primary" (click)="navigate('/freedemo')">
              Enroll Now
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
            <button class="ep-btn-ghost" (click)="navigate('/freedemo')">Book Free Demo</button>
          </div>

          <div class="ep-hero-stats">
            <div class="ep-hstat">
              <span class="ep-hstat-num">10K+</span>
              <span class="ep-hstat-lbl">Students Placed</span>
            </div>
            <div class="ep-hstat-line"></div>
            <div class="ep-hstat">
              <span class="ep-hstat-num">4</span>
              <span class="ep-hstat-lbl">Exam Boards</span>
            </div>
            <div class="ep-hstat-line"></div>
            <div class="ep-hstat">
              <span class="ep-hstat-num">98%</span>
              <span class="ep-hstat-lbl">Pass Rate</span>
            </div>
          </div>
        </div>

        <!-- Right: Feature Cards -->
        <div class="ep-hero-right">
          <div class="ep-hero-cards-grid">

            <a class="ep-hero-fcard" (click)="navigate('/product-services')">
              <div class="ep-hero-fcard-img">
                <img src="assets/images/hft-1.jpg" alt="Online Tutoring"/>
                <div class="ep-hero-fcard-hover">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
              </div>
              <div class="ep-hero-fcard-body">
                <h4>Online Tutoring</h4>
                <span class="ep-hero-fcard-tag">1-2-1 &amp; Group</span>
              </div>
            </a>

            <a class="ep-hero-fcard" (click)="navigate('/11plus-mock-test')">
              <div class="ep-hero-fcard-img">
                <img src="assets/images/hft-2.jpg" alt="Mock Exams"/>
                <div class="ep-hero-fcard-hover">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
              </div>
              <div class="ep-hero-fcard-body">
                <h4>Mock Exams</h4>
                <span class="ep-hero-fcard-tag">Full Papers</span>
              </div>
            </a>

            <a class="ep-hero-fcard" (click)="navigate('/product-services')">
              <div class="ep-hero-fcard-img">
                <img src="assets/images/hft-3.jpg" alt="Crash Courses"/>
                <div class="ep-hero-fcard-hover">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
              </div>
              <div class="ep-hero-fcard-body">
                <h4>Crash Courses</h4>
                <span class="ep-hero-fcard-tag">Intensive</span>
              </div>
            </a>

            <a class="ep-hero-fcard" (click)="navigate('/11plus-sprint')">
              <div class="ep-hero-fcard-img">
                <img src="assets/images/elv-sprint.jpg" alt="11+ Sprint Success"/>
                <div class="ep-hero-fcard-hover">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
              </div>
              <div class="ep-hero-fcard-body">
                <h4>11+ Sprint Success</h4>
                <span class="ep-hero-fcard-tag ep-tag-gold">Fast Track</span>
              </div>
            </a>

          </div>
        </div>

      </div>
    </div>

    <!-- Wave divider -->
    <svg class="ep-hero-wave" viewBox="0 0 1440 64" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path d="M0 64L60 54C120 44 240 24 360 18C480 12 600 24 720 30C840 36 960 40 1080 36C1200 32 1320 16 1380 8L1440 0V64H0Z" fill="#F4F8FA"/>
    </svg>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       WHAT PARENTS SAY — REDESIGNED
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-section ep-bg-white" id="ep-testi">
    <div class="ep-container">

      <div class="ep-section-header ep-reveal">
        <div class="ep-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          Parent Stories
        </div>
        <h2 class="ep-section-title">What Parents Say About Us?</h2>
        <p class="ep-section-lead">Real success stories from families who chose Sehyog Academy for their child's 11+ journey.</p>
      </div>

      <!-- Featured video + testimonial cards layout -->
      <div class="ep-testi-layout ep-reveal">

        <!-- Left: large featured video -->
        <div class="ep-testi-featured">
          <div class="ep-testi-video-wrap">
            <div class="ep-testi-video-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              Featured Story
            </div>
            <div class="ep-video-ratio">
              <iframe
                src="https://www.youtube.com/embed/Q9O1heDQfHI?si=L6dN-k9-bHMIJhma"
                title="Happy Parents Speak: Success Stories 01"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
              </iframe>
            </div>
          </div>
          <div class="ep-testi-feat-foot">
            <div class="ep-testi-feat-stars">★★★★★</div>
            <p class="ep-testi-feat-quote">"The structured approach and consistent feedback made all the difference. My daughter got into her first-choice grammar school!"</p>
            <div class="ep-testi-feat-author">
              <div class="ep-testi-author-avatar">P</div>
              <div>
                <div class="ep-testi-author-name">Happy Parent</div>
                <div class="ep-testi-author-school">Grammar School Success</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: stacked mini videos + text cards -->
        <div class="ep-testi-right">

          <!-- Mini video 2 -->
          <div class="ep-testi-mini ep-reveal ep-d1">
            <div class="ep-testi-mini-video">
              <div class="ep-video-ratio">
                <iframe
                  src="https://www.youtube.com/embed/fVU0xDgiclA"
                  title="Happy Parents Speak: Success Stories 02"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen>
                </iframe>
              </div>
            </div>
            <div class="ep-testi-mini-info">
              <div class="ep-testi-mini-stars">★★★★★</div>
              <p class="ep-testi-mini-text">"Brilliant tutors and personalised attention throughout the whole process."</p>
              <span class="ep-testi-mini-tag">Success Story</span>
            </div>
          </div>

          <!-- Mini video 3 -->
          <div class="ep-testi-mini ep-reveal ep-d2">
            <div class="ep-testi-mini-video">
              <div class="ep-video-ratio">
                <iframe
                  src="https://www.youtube.com/embed/fVU0xDgiclA"
                  title="Happy Parents Speak: Success Stories 03"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen>
                </iframe>
              </div>
            </div>
            <div class="ep-testi-mini-info">
              <div class="ep-testi-mini-stars">★★★★★</div>
              <p class="ep-testi-mini-text">"The mock tests and RAR reports helped us understand exactly where to focus."</p>
              <span class="ep-testi-mini-tag">Success Story</span>
            </div>
          </div>

          <!-- Stat chips row -->
          <div class="ep-testi-stats ep-reveal ep-d3">
            <div class="ep-testi-stat">
              <span class="ep-testi-stat-num">10K+</span>
              <span class="ep-testi-stat-lbl">Students Placed</span>
            </div>
            <div class="ep-testi-stat">
              <span class="ep-testi-stat-num">98%</span>
              <span class="ep-testi-stat-lbl">Pass Rate</span>
            </div>
            <div class="ep-testi-stat">
              <span class="ep-testi-stat-num">5★</span>
              <span class="ep-testi-stat-lbl">Avg Rating</span>
            </div>
          </div>

          <div class="ep-reveal ep-d3">
            <button class="ep-btn-primary ep-testi-cta-btn" (click)="navigate('/testimonials')">
              View All Stories
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>

        </div>
      </div>

    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       STRIP BANNER
  ══════════════════════════════════════════════════════════════ -->
  <div class="ep-strip ep-reveal">
    <div class="ep-container ep-strip-inner">
      <div class="ep-strip-left">
        <span class="ep-strip-num">10K+</span>
        <span class="ep-strip-text">
          Successful Students placed at top<br/>
          <strong>Grammar Schools in the UK</strong>
        </span>
      </div>
      <button class="ep-btn-strip" (click)="navigate('/freedemo')">Enroll Now</button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       SEHYOG STRATEGY — SLIDER
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-section ep-bg-light" id="ep-strategy">
    <div class="ep-container">

      <div class="ep-section-header ep-reveal">
        <div class="ep-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
          Our Approach
        </div>
        <h2 class="ep-section-title">SEHYOG Strategy</h2>
        <p class="ep-section-lead">Comprehensive Offerings Under One Umbrella</p>
      </div>

      <!-- Slider -->
      <div class="ep-slider-wrap ep-reveal">
        <button class="ep-slider-nav ep-slider-prev" (click)="sliderPrev()" aria-label="Previous">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button class="ep-slider-nav ep-slider-next" (click)="sliderNext()" aria-label="Next">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>

        <div
          class="ep-slider-viewport"
          #sliderViewport
          tabindex="0"
          (keydown)="onSliderKeydown($event)"
          (pointerdown)="sliderDragStart($event)"
          (pointermove)="sliderDragMove($event)"
          (pointerup)="sliderDragEnd($event)"
          (pointerleave)="sliderDragEnd($event)"
        >
          <article
            class="ep-slider-card"
            #sliderCard
            *ngFor="let card of sliderData; let i = index"
            (click)="toggleOverlay(i)"
            (mouseleave)="hideOverlay()"
          >
            <div class="ep-slider-card-text">
              <h3 class="ep-slider-title">{{ card.title }}</h3>
              <p class="ep-slider-subtitle">{{ card.subtitle }}</p>
            </div>
            <div class="ep-slider-card-img">
              <img [src]="card.img" [alt]="card.imgAlt" loading="lazy"/>
            </div>
            <div class="ep-slider-overlay" [class.ep-overlay-show]="showOverlayIndex === i">
              <div [innerHTML]="card.desc"></div>
            </div>
          </article>
        </div>

        <div class="ep-slider-dots">
          <button
            *ngFor="let card of sliderData; let i = index"
            class="ep-slider-dot"
            [class.ep-dot-active]="i === sliderCurrentIndex"
            (click)="sliderGoTo(i)"
            [attr.aria-label]="'Go to slide ' + (i + 1)">
          </button>
        </div>
      </div>

    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       COURSES & SUBJECTS
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-section ep-bg-white" id="ep-subjects">
    <div class="ep-container">

      <div class="ep-section-header ep-reveal">
        <div class="ep-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
          What We Cover
        </div>
        <h2 class="ep-section-title">Courses &amp; Subjects We Offer</h2>
        <p class="ep-section-lead">Complete curriculum covering every topic tested in the 11+ entrance exams.</p>
      </div>

      <!-- Subjects list -->
      <div class="ep-subjects-wrap ep-reveal">
        <div class="ep-subjects-row ep-subjects-row-1">
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg></div>
            Mathematics
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg></div>
            English Grammar
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></div>
            Creative Writing
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div>
            Reading Comprehension
          </div>
        </div>
        <div class="ep-subjects-row">
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg></div>
            Verbal Reasoning
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></div>
            Non-Verbal Reasoning
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg></div>
            Spatial Reasoning
          </div>
          <div class="ep-subj-chip">
            <div class="ep-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg></div>
            Quantitative Reasoning
          </div>
        </div>
      </div>

      <!-- Course Cards -->
      <div class="ep-courses-grid">

        <div class="ep-course-card ep-reveal">
          <div class="ep-course-hdr ep-course-hdr-primary">
            <div class="ep-course-hdr-top">
              <span class="ep-course-badge">Most Popular</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </div>
            <h3>Fast Forward Course
              <span class="ep-course-hdr-icon">▶▶</span>
            </h3>
            <p>Fast forward Course for Year 5, Year 4 and Year 3 Students</p>
          </div>
          <div class="ep-course-body">
            <div class="ep-course-info-row">
              <span class="ep-info-label">Recommended For</span>
              <span class="ep-info-val">Year 5, 4 &amp; 3 students</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Duration</span>
              <span class="ep-info-val">35 – 45 Weeks</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Sessions</span>
              <span class="ep-info-val">105 – 315 Sessions</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Fee Schedule</span>
              <span class="ep-info-val">Advance One Time / Monthly Payment</span>
            </div>
            <div class="ep-course-provided-title">Provided</div>
            <ul class="ep-course-feat-list">
              <li>Course Structure &amp; Pre-Lecture Material (PLM)</li>
              <li>Daily / Weekly Home / Class Work</li>
              <li>Face to Face Unit &amp; Topic Tests</li>
              <li>Fortnightly Revision Tests</li>
              <li>Weekly Doubt Clearing Sessions</li>
            </ul>
            <button class="ep-btn-primary ep-course-btn" (click)="navigate('/freedemo')">Book a Free Demo</button>
          </div>
        </div>

        <div class="ep-course-card ep-reveal ep-d2">
          <div class="ep-course-hdr ep-course-hdr-dark">
            <div class="ep-course-hdr-top">
              <span class="ep-course-badge ep-badge-gold">Flexible</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
            </div>
            <h3>Regular Course <span class="ep-payg-label">Pay As You Go</span></h3>
            <p>Basics to Best Level 11+ Preparation for Year 3, 4 &amp; 5 Students</p>
          </div>
          <div class="ep-course-body">
            <div class="ep-course-info-row">
              <span class="ep-info-label">Recommended For</span>
              <span class="ep-info-val">Year 5, 4 &amp; 3 students</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Duration</span>
              <span class="ep-info-val">Flexible</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Sessions</span>
              <span class="ep-info-val">Flexible</span>
            </div>
            <div class="ep-course-info-row">
              <span class="ep-info-label">Fee Schedule</span>
              <span class="ep-info-val">Monthly Payment</span>
            </div>
            <div class="ep-course-provided-title">Provided</div>
            <ul class="ep-course-feat-list">
              <li>Course Structure &amp; Pre-Lecture Material (PLM)</li>
              <li>Daily / Weekly Home / Class Work</li>
              <li>Face to Face Unit &amp; Topic Tests</li>
              <li>Revision Tests</li>
              <li>Doubt Clearing Sessions</li>
            </ul>
            <button class="ep-btn-gold ep-course-btn" (click)="navigate('/freedemo')">Book a Free Demo</button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       RESULT ANALYSIS REPORT (RAR) — REDESIGNED
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-rar-section" id="ep-rar">
    <div class="ep-container">

      <!-- Section header -->
      <div class="ep-section-header ep-reveal">
        <div class="ep-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
          Performance Tracking
        </div>
        <h2 class="ep-section-title">Result Analysis Report</h2>
        <p class="ep-section-lead">Detailed insights into every aspect of your child's test performance — so you know exactly what to improve.</p>
      </div>

      <!-- Main RAR card — dark navy -->
      <div class="ep-rar-card ep-reveal">

        <!-- Background decoration -->
        <div class="ep-rar-card-bg"></div>

        <!-- Left: feature list + CTA -->
        <div class="ep-rar-card-left">

          <!-- Stat chips row -->
          <div class="ep-rar-chips">
            <div class="ep-rar-chip">
              <div class="ep-rar-chip-num">3</div>
              <div class="ep-rar-chip-lbl">Report Dimensions</div>
            </div>
            <div class="ep-rar-chip">
              <div class="ep-rar-chip-num">100%</div>
              <div class="ep-rar-chip-lbl">Subject Coverage</div>
            </div>
            <div class="ep-rar-chip">
              <div class="ep-rar-chip-num">Live</div>
              <div class="ep-rar-chip-lbl">After Every Mock</div>
            </div>
          </div>

          <!-- Feature items -->
          <div class="ep-rar-items">
            <div class="ep-rar-item">
              <div class="ep-rar-item-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
              </div>
              <div class="ep-rar-item-body">
                <h4>Subject-wise Marks Analysis</h4>
                <p>A complete breakdown per subject — pinpoint exactly where your child is strong and where they need to focus next.</p>
              </div>
              <div class="ep-rar-item-num">01</div>
            </div>

            <div class="ep-rar-item">
              <div class="ep-rar-item-icon ep-rar-icon-s">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
              </div>
              <div class="ep-rar-item-body">
                <h4>Section-wise Score Comparison</h4>
                <p>Compare performance across every paper section side-by-side to identify consistent patterns.</p>
              </div>
              <div class="ep-rar-item-num">02</div>
            </div>

            <div class="ep-rar-item">
              <div class="ep-rar-item-icon ep-rar-icon-g">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              </div>
              <div class="ep-rar-item-body">
                <h4>Correct &amp; Incorrect Attempts</h4>
                <p>Understand error patterns question-by-question — target revision exactly where it will have the most impact.</p>
              </div>
              <div class="ep-rar-item-num">03</div>
            </div>
          </div>

          <!-- CTA inside the dark card -->
          <div class="ep-rar-card-cta">
            <button class="ep-rar-cta-btn" (click)="navigate('/freedemo')">
              Get Your Child's RAR
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
            <p class="ep-rar-cta-note">Available after every mock test session</p>
          </div>

        </div>

        <!-- Right: image -->
        <div class="ep-rar-card-right">
          <div class="ep-rar-img-frame">
            <img src="assets/images/ep-rar.png" alt="Result Analysis Report"/>
            <!-- Floating label -->
            <div class="ep-rar-img-tag">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              Live Report
            </div>
          </div>
        </div>

      </div>

    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       CTA BOTTOM
  ══════════════════════════════════════════════════════════════ -->
  <section class="ep-cta-section ep-reveal">
    <div class="ep-container">
      <div class="ep-cta-inner">
        <div class="ep-cta-text">
          <h2>Start Your 11+ Journey<br/><em>with Sehyog Today</em></h2>
          <p>Join thousands of students who have secured places at top UK grammar schools.</p>
        </div>
        <div class="ep-cta-actions">
          <button class="ep-btn-primary ep-btn-lg" (click)="navigate('/freedemo')">
            Book a Free Demo
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </button>
          <button class="ep-btn-outline-light" (click)="navigate('/product-services')">View All Courses</button>
        </div>
      </div>
    </div>
  </section>

</div>